module.exports = __webpack_public_path__ + "static/LucasPope7-ca29c4d05a50162b56c212fcdc8bc197.png";